import { cn } from "@shared/lib";

export interface OverviewEmptyStateProps {
  title: string;
  body: string;
  className?: string | undefined;
}

export function OverviewEmptyState({
  title,
  body,
  className,
}: OverviewEmptyStateProps) {
  return (
    <div
      role="status"
      className={cn(
        "flex flex-col items-center gap-3 rounded-lg border border-dashed bg-background p-8 text-center",
        className,
      )}
    >
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="max-w-sm text-sm text-muted-foreground">{body}</p>
    </div>
  );
}
